import { Stack, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	InvestmentValueFormInput,
	InvestmentValueFormOutput,
} from "web_myplann/Portfolio/Components/Redesign/Detail/Value/investmentValueFormSchema";
import { FlatRowFormDatePicker } from "web_myplann/Shared/Components/FlatRow/FlatRowFormDatePicker";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { DateView } from "web_myplann/Shared/Types/DateView";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

type InvestmentValueFormFieldsProps = {
	control: Control<
		InvestmentValueFormInput,
		unknown,
		InvestmentValueFormOutput
	>;
	currencySign: string;
};

const PageResources = Resources.PortfolioDetail.InvestmentValue;

export const InvestmentValueFormFields = ({
	control,
	currencySign,
}: InvestmentValueFormFieldsProps) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack bgcolor={theme.palette.background.paper}>
			<FlatRowFormInput
				control={control}
				name="value"
				type="number"
				label={t(PageResources.newValue)}
				placeholder={t(PageResources.placeholder)}
				suffix={currencySign}
			/>
			<FlatRowFormInput
				control={control}
				name="invested"
				type="number"
				label={t(PageResources.invested)}
				placeholder={t(PageResources.placeholder)}
				suffix={currencySign}
			/>
			<FlatRowFormDatePicker
				control={control}
				name="date"
				label={t(PageResources.date)}
				views={[DateView.Year, DateView.Month, DateView.Day]}
				displayFormat={DateFormat.Display}
				maxDate={new Date()}
				isLast
			/>
		</Stack>
	);
};
